import {ref} from "vue";

export function useCurrentPath() {
    const url = ref(window.location.href);

    return {url};
}
